<template>
    <div
        :class="[
            appearance,
            'badge p-1 text-xs border-none rounded-md py-0 leading-loose flex items-center justify-center',
        ]"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        appearance: {
            type: String,
            required: false,
            default: 'default',
            validator(value) {
                // The value must match one of these strings
                return (
                    [
                        'default',
                        'karma',
                        'credits',
                        'coins',
                    ].indexOf(value) !== -1
                );
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.badge {
    min-width: 2rem;
    &.karma {
        @apply bg-purple-700 text-purple-700 bg-opacity-05;
    }

    &.credits {
        @apply bg-orange-200 text-yellow-500 bg-opacity-05;
    }

    &.coins {
        @apply bg-purple-200 text-purple-800;
    }

    &.default {
        @apply bg-slate-100  text-slate-600;
    }
}
</style>
